import { useClient } from "@adamlip/okeoke.client"
import LocationSelector from "components/LocationSelector"
import { BasketContext } from "contexts/BasketContext"
import { useContext, useEffect, useState } from "react"
import SelectLocationModal from "components/SelectLocationModal"
import OrderItems from "./OrderItems"
import { AppParamsContext } from "contexts/AppParamsContext"
import OrderHeader from "views/Order/OrderHeader"

export default function Order() {
  const { locations } = useClient()
  const { appParams } = useContext(AppParamsContext)
  const { isUserSelectedLocation } = useContext(BasketContext)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (
      Object.values(locations || {}).filter(
        (location) => location.enabled === 1
      )?.length > 1
    ) {
      if (
        !isUserSelectedLocation &&
        appParams?.styles?.global?.showLocationSelectorBeforeOrderItems !==
        false
      ) {
        setIsOpen(true)
      }
    }
  }, [isUserSelectedLocation, appParams, locations])

  return (
    <div className="flex flex-col overflow-hidden grow h-full min-h-full">
      <SelectLocationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isDismissable={true}
      />
      {appParams?.order?.orderLocationSelector && <LocationSelector />}
      <OrderHeader />
      <OrderItems readOnly={appParams?.order?.menuReadOnly} />
    </div>
  )
}
